import color from 'assets/scss/_color.module.scss';

export const colors = {
  ...color,
};
